import { ControlPosition, data } from 'azure-maps-control';

import { PopupState } from './useWorldMap.types';

export const defaultPosition: data.Position = [0, 0];

export const initialPopupState: PopupState = {
  isVisible: false,
  position: defaultPosition,
  properties: {
    isActive: false
  }
};

export const mapScrollAnimationBase = {
  duration: 200,
  type: 'ease' as const
};

export const defaultMapControls = [
  {
    controlName: 'ZoomControl',
    controlOptions: { style: 'light', zoomDelta: 1 },
    options: { position: ControlPosition.BottomRight }
  }
];
